import { ImageViewModal, TypeImageItemExtractor } from '~/components/common';

const ClaimDetailInspectionImageModal = ({
  mode,
  isOpen,
  imageList,
  onClose,
}: {
  mode: 'return' | 'exchange';
  isOpen: boolean;
  imageList: string[];
  onClose: () => void;
}) => {
  const extractor: TypeImageItemExtractor<string> = {
    getId: (item) => item,
    getUrl: (item) => item,
  };

  const getAltText = (_: string, index: number) =>
    `${mode === 'return' ? '반품' : '교환'} 신청 검수 이미지 ${index + 1}`;

  return (
    <ImageViewModal
      title="검수 이미지"
      size="small"
      isOpen={isOpen}
      imageList={imageList}
      extractor={extractor}
      getAltText={getAltText}
      onClose={onClose}
    />
  );
};

export default ClaimDetailInspectionImageModal;
